module.exports = __webpack_public_path__ + "static/img/80016A_R_all_20170816_LC.2d3fd36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/80016A_R_all_20170816_LC.png
// module id = Fxlr
// module chunks = 0